import Lost from "./lost.jsx";
export default Lost;
